import gb from 'date-fns/locale/en-GB'
import setDefaultOptions from 'date-fns/setDefaultOptions'

setDefaultOptions({
  locale: gb,
  weekStartsOn: 1,
})
